export const TABS = {
	INFO: { value: 'info', label: 'info', path: 'info' },
	CONTENT: { value: 'files', label: 'files', path: 'files' },
	OPTIONS: { value: 'options', label: 'options', path: 'options' },
	FIX_REQUESTS: { value: 'fix requests', label: 'fix requests', path: 'fixRequest' },
	NOTES: { value: 'notes', label: 'notes', path: 'notes' },
	ADMIN: { value: 'admin', label: 'admin', path: 'admin' }
};
